<template>
  <div>
      <!-- TipoInstitucion -->
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un Cargo</option>
        <option v-for="Cargo in Cargos" :key="Cargo.CargoID" :value="Cargo.CargoID">{{Cargo.Descripcion}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        Cargos: [],
        idDelModelo: null,
        IdInstitucion:0        
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idOrden: Number,
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      IdInst: Number
    },
    mounted() {
      this.params = this.parametros
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      this.IdInstitucion = this.IdInst;
      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo,
      }
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerCargo", params);
    },
    methods: {
      cargaCargos() {
          let peticion = {
            IdInstitucion: this.$store.state.TemisCivil_Catalogos_AutoridadId.valor,
            EsPrueba: this.enumeraciones.EsPrueba
          }
        axios.post(api.conexion + api.TemisCivil.catalogos.Cargos, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              if(respuesta.data._Cargos.length > 0)
              {
                this.Cargos = respuesta.data._Cargos;
                this.idDelModelo = this.Cargos[0].CargoID;
                this.cambiaCargoInicial();
                return respuesta.data._Cargos;
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const params = {
          llave: this.idDelModelo,
          valor: evento.target.value,
        }

        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerCargo", params);
      },
      cambiaCargoInicial: function(){
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerCargo", { llave: this.idDelInput, valor: this.idDelModelo });
      }
    },
    created() {
      this.cargaCargos();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/Cargos.vue